import type { FaireProductEntity } from "../../entity_types/product";

export const p_rw8k679bpz: FaireProductEntity = {
  token: "p_rw8k679bpz",
  type: "product",
  name: "KIDS GARDENING SET, PETAL",
  brandToken: "b_a9ry3a7qtm",
  brandName: "Kinderific",
  imageUrl:
    "https://cdn.faire.com/fastly/718809a708818e99147b348ae75860ecafe91c0c78592b1f42d59fa88b135c5a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81943300bce8c5611d87dd02af6f1bb833ab44af151d26bee158c270bc4cbfee.jpeg",
    "https://cdn.faire.com/fastly/1e5dc07890dcca99c42d94909cd05c3a903a5ea2d4b6973ff7419ecc638547b2.jpeg",
    "https://cdn.faire.com/fastly/4381a15243c81d0659cdc22ed66b27c30c1377b98462907c348bfd77d08ce9a6.jpeg",
    "https://cdn.faire.com/fastly/53833546a373bce6e5edf05c4ef4583c537f07aed76495c144f8e98f8c52b437.jpeg",
    "https://cdn.faire.com/fastly/aa4c6683a31dc1527396da326b5c655f81316019f02c6ef2e68f40d825dd582d.jpeg",
  ],
  priceDollars: 16.95,
  description:
    "Kinderific Gardening Set, Tool Kit, For Kids, STEM, Includes Tote Bag, Spade, Watering Can, Rake, Fork, Trowel and Gloves.\n\n\n\n🌱 Fun & Educational: Have fun digging, planting and watering! This set is perfect for teaching kids the basics of gardening in a safe and exciting way.\n\n🌱 Just For Kids!: All tools are child-friendly, colorful and lightweight. They are designed to allow kids to experiment while staying safe.\n\n🌱 Complete Set: Includes a bright canvas tote, large 22 ounce watering can, gardening gloves, rake, shovel and fork. Each tool is made with high quality wooden handles and metal heads.\n\n🌱 Fine Motor Skills: This set encourages children to get curious and imaginative in the outdoors! It’s an amazing way for young kids to develop fine and gross motor skills while playing.\n\n🌱 Satisfaction Guarantee: We’ve carefully packaged this Gardening Set to ensure it arrives in perfect condition.\n",
  tags: [],
  msrpDollars: 33.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:25.827Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
